var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"font-bold py-2 px-4 rounded focus:outline-none",class:`bg-${_vm.color} hover:bg-${_vm.hoverColor} text-${_vm.typoColor} ${_vm.additionalClasses}`,on:{"click":function($event){return _vm.onClick($event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }